/* Najczesciej wystepujace liczby z publicznej historii losowan.
 *
 * Modul pobiera wyłącznie publiczny plik wynikow. Nie wysyla wpisanych ani
 * zapisanych przez uzytkownika liczb. Przy remisie wyzej jest liczba, ktora
 * wystapila pozniej, a potem liczba o nizszej wartosci.
 */
(function (root, factory) {
    'use strict';
    var api = factory(root);
    if (typeof module === 'object' && module && module.exports) { module.exports = api; }
    root.PewniakiNajczestsze = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
    'use strict';

    var GRY = ['lotto', 'lotto-plus', 'mini-lotto', 'multi-multi', 'eurojackpot', 'kaskada', 'keno'];
    var cache = {};

    function json(url) {
        if (!root.fetch) { return Promise.reject(Error('fetch')); }
        return root.fetch(url, { credentials: 'same-origin' }).then(function (response) {
            if (!response.ok) { throw Error('http'); }
            return response.json();
        });
    }

    function adres(gra) {
        if (GRY.indexOf(gra) < 0) { return Promise.reject(Error('game')); }
        if (gra !== 'keno') { return Promise.resolve('/assets/json/db/' + gra + '/recent.json'); }
        return json('/assets/json/db/keno/aktualna.json').then(function (pointer) {
            if (!pointer || !/^g-[a-zA-Z0-9-]+$/.test(pointer.generacja || '')) { throw Error('pointer'); }
            return '/assets/json/db/keno/' + pointer.generacja + '/recent.json';
        });
    }

    function historia(gra) {
        if (cache[gra]) { return cache[gra]; }
        cache[gra] = adres(gra).then(json).then(function (data) {
            if (!data || !Array.isArray(data.draws)) { throw Error('draws'); }
            return data.draws;
        }).catch(function (error) {
            delete cache[gra];
            throw error;
        });
        return cache[gra];
    }

    function ranking(draws, pula, ile, pole, limit) {
        pula = Number(pula);
        ile = Number(ile);
        limit = Number(limit || 25);
        pole = pole === 'special' ? 'special' : 'numbers';
        if (!Array.isArray(draws) || !Number.isInteger(pula) || pula < 1 || pula > 100 ||
            !Number.isInteger(ile) || ile < 1 || ile > pula || !Number.isInteger(limit) || limit < 1) {
            throw Error('options');
        }
        var rows = draws.map(function (draw) {
            var time = draw && typeof draw.drawn_at === 'string' ? Date.parse(draw.drawn_at) : NaN;
            if (!Number.isFinite(time) || !Array.isArray(draw[pole])) { throw Error('draw'); }
            var seen = {};
            draw[pole].forEach(function (n) {
                if (!Number.isInteger(n) || n < 1 || n > pula || seen[n]) { throw Error('number'); }
                seen[n] = true;
            });
            return { time: time, numbers: draw[pole] };
        }).sort(function (a, b) { return b.time - a.time; }).slice(0, limit);
        if (!rows.length) { throw Error('empty'); }

        var counts = Array(pula + 1).fill(0);
        var recent = Array(pula + 1).fill(Infinity);
        rows.forEach(function (row, rank) {
            row.numbers.forEach(function (n) {
                counts[n]++;
                if (recent[n] === Infinity) { recent[n] = rank; }
            });
        });
        var numbers = [];
        for (var n = 1; n <= pula; n++) { numbers.push(n); }
        numbers.sort(function (a, b) {
            return counts[b] - counts[a] || recent[a] - recent[b] || a - b;
        });
        return numbers.slice(0, ile).sort(function (a, b) { return a - b; });
    }

    function wybierz(gra, pula, ile, pole, limit) {
        return historia(gra).then(function (draws) { return ranking(draws, pula, ile, pole, limit || 25); });
    }

    return { wybierz: wybierz, ranking: ranking };
});
